export const DEFAULT_PAGE_SIZE = 100;
export const PAGE_SIZES = [10, 25, 50, 100];
